import React from "react";
import { View, Text, Modal, TouchableOpacity, StyleSheet } from "react-native";
import { AppTheme, useTheme } from "../theme/colors";
interface CustomAlertProps {
  visible: boolean;
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  cancelText: string;
  confirmText: string;
  showCancelButton: boolean;
}

const CustomAlert: React.FC<CustomAlertProps> = ({
  visible,
  title,
  message,
  showCancelButton,
  onCancel,
  onConfirm,
  cancelText,
  confirmText,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={() => {
        onCancel();
      }}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Text style={styles.modalTitle}>{title}</Text>
          <Text style={styles.modalMessage}>{message}</Text>
          <View style={styles.buttonContainer}>
            {showCancelButton && (
              <TouchableOpacity
                style={[styles.button, styles.cancelButton]}
                onPress={onCancel}
              >
                <Text>{cancelText}</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity
              style={[styles.button, styles.confirmButton]}
              onPress={() => {
                onConfirm();
              }}
            >
              <Text style={styles.buttonText}>{confirmText}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

CustomAlert.defaultProps = {
  cancelText: "Cancel",
  confirmText: "OK",
};

const getStyles = (theme: AppTheme) =>
  StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    modalView: {
      backgroundColor: theme.BACKGROUND,
      borderRadius: 10,
      padding: 20,
      alignItems: "center",
      shadowColor: "black",
      shadowOffset: {
        width: 10,
        height: 10,
      },
      shadowOpacity: 0.25,
      shadowRadius: 10,
      elevation: 10,
    },
    modalTitle: {
      fontSize: 20,
      fontWeight: "bold",
      marginBottom: 10,
      color: theme.TEXT,
    },
    modalMessage: {
      fontSize: 16,
      marginBottom: 20,
      color: theme.TEXT,
    },
    buttonContainer: {
      flexDirection: "row",
    },
    button: {
      padding: 10,
      borderRadius: 5,
      marginHorizontal: 10,
      minWidth: 80,
      alignItems: "center",
    },
    cancelButton: {
      backgroundColor: theme.ACCENT,
    },
    confirmButton: {
      backgroundColor: theme.PRIMARY,
    },
    buttonText: {
      color: "white",
      fontWeight: "bold",
    },
  });

export default CustomAlert;
